var React = require('react');

function HeaderArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 13L9 10","stroke":"#808693","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M12 12.9988L14.9685 10.0175","stroke":"#808693","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

HeaderArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = HeaderArrow;

HeaderArrow.default = HeaderArrow;
